const styles = {
    boxWidth: "xl:max-w-[1280px] w-full",

    heading1: "font-poppins font-semibold xs:text-[60px] text-[40px] text-white xs:leading-[76.8px] leading-[50.8px] w-full",
    heading2: "font-poppins font-semibold xs:text-[48px] text-[40px] text-white xs:leading-[76.8px] leading-[50.8px] w-full",

    paragraph: "font-poppins font-normal text-white text-[18px] leading-[30.8px]",

    flexCenter: "flex justify-center items-center",
    flexStart: "flex justify-center items-start",
    
    paddingX: "sm:px-16px px-6",
    paddingY: "sm:py-16 py-6",
    marginX: "sm:mx-16 mx-6",
    marginY: "sm:mx-16 mx-6",
}



export default styles